export default "__VITE_PUBLIC_ASSET__59ece790__"